
export default {
    name: 'LeeInputNumber',
    inheritAttrs: false,
    data() {
        return {
            currentValue: 0
        };
    },
    mounted() {},
    props: {
        value: {
            type: Number,
            default: 1 //默认1
        },
        min: {
            type: Number,
            default: -Infinity //默认1
        },
        max: {
            type: Number,
            default: Infinity //默认1
        }
    },
    methods: {
        dec() {
            this.currentValue--;
            if (this.currentValue < this.min) {
                this.currentValue = this.min
                return
            }
            this.$emit('input', this.currentValue);
            this.$emit('change', this.currentValue);

        },
        inc() {
            this.currentValue++;
            if (this.currentValue > this.max) {
                this.currentValue = this.max
                return
            }
            this.$emit('input', this.currentValue);
            this.$emit('change', this.currentValue);

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                var newVal = Number(value);
                if (isNaN(newVal)) {
                    newVal = this.currentValue
                }
                if (newVal >= this.max) newVal = this.max;
                if (newVal <= this.min) newVal = this.min;
                this.currentValue = newVal;
                this.$emit('input', newVal);
            }
        }
    },
    computed: {
        inputListeners() {
            var vm = this;
            return Object.assign({}, this.$listeners, {
                // 这里确保组件配合 `v-model` 的工作
                input: function(event) {
                    //var jg = Number(event.target.value)
                    //vm.$emit('input', jg);
                },
                change: function(event) {
                    var jg = Number(event.target.value)
                    if (isNaN(jg)) {
                        jg = vm.currentValue
                    }
                    if (jg >= vm.max) jg = vm.max;
                    if (jg <= vm.min) jg = vm.min;
                    vm.$refs.input.value = jg;
                    vm.$emit('change', jg)
                    vm.$emit('input', jg)
                }
            })
        }
    }
};
